import {
  reqInstantList,
  reqRoadList,
  reqReserveBeforeList,
  reqReserveAfterList,
} from '@/api/transaction'
import { reqList } from '@/api/reservation'
import { instantPick } from '@/constants/select'
import { Notification, Loading } from 'element-ui'

function taskStr(id) {
  const pickObj = instantPick.find((pick) => pick.id === id)
  if (pickObj) {
    return pickObj.task
  }
  return ''
}

export default {
  async fetchList({ state, commit }) {
    // 機場接送不需要時間範圍也能查詢，其他 tab 需要時間範圍
    const needTimeRange = state.activeTab !== 'airport'
    if ((state.search.start && state.search.end) || !needTimeRange) {
      const loading = Loading.service()
      try {
        if (state.activeTab === 'instant') {
          // 立即單
          const params = {
            npp: state.instantPaging.npp,
            page: state.instantPaging.currentPage,
            kw: state.kw,
            rule: state.rule,
            startTime: state.search.start,
            endTime: state.search.end,
            task: taskStr(state.instantPick),
          }
          const res = await reqInstantList(params)
          commit('setInstantPagingTotalEntries', res.total)
          commit(
            'setInstantPagingTotalPages',
            Math.ceil(res.total / state.instantPaging.npp),
          )
          commit('setInstantList', res.list)
          // console.log("立即單", res);
        } else if (state.activeTab === 'road') {
          // 路招單
          const params = {
            npp: state.roadPaging.npp,
            page: 1,
            kw: state.kw,
            rule: state.rule,
            startTime: state.search.start,
            endTime: state.search.end,
            task: 'roadHail',
          }
          const res = await reqRoadList(params)
          if (res) {
            commit('setRoadPagingTotalEntries', res.total)
            commit(
              'setRoadPagingTotalPages',
              Math.ceil(res.total / state.roadPaging.npp),
            )
            commit('setRoadList', res.list)
          }
          // console.log("路招單", res);
        } else if (state.activeTab === 'reserveBefore') {
          // 預約前派單
          const params = {
            npp: state.reserveBeforePaging.npp,
            page: state.reserveBeforePaging.currentPage,
            keyword: state.kw,
            rule: state.rule,
            start: state.search.start,
            end: state.search.end,
            task: 'record',
          }
          const { result } = await reqReserveBeforeList(params)
          commit('setReserveBeforePagingTotalEntries', result.total)
          commit(
            'setReserveBeforePagingTotalPages',
            Math.ceil(result.total / state.reserveBeforePaging.npp),
          )
          commit('setReserveBeforeList', result.billList)
          // console.log("預約前派單", result);
        } else if (state.activeTab === 'reserveAfter') {
          // 預約後派單
          const params = {
            npp: state.reserveAfterPaging.npp,
            page: state.reserveAfterPaging.currentPage,
            keyword: state.kw,
            rule: state.rule,
            start: state.search.start,
            end: state.search.end,
          }
          const { result } = await reqReserveAfterList(params)
          commit('setReserveAfterPagingTotalEntries', result.total)
          commit(
            'setReserveAfterPagingTotalPages',
            Math.ceil(result.total / state.reserveAfterPaging.npp),
          )
          commit('setReserveAfterList', result.list)
          // console.log("預約後派單", result);
        } else if (state.activeTab === 'airport') {
          // 機場接送
          const params = {
            npp: state.airportTransferPaging.npp,
            page: state.airportTransferPaging.currentPage,
            keyword: state.kw,
            rule: state.rule,
            sort: 'createdAt',
            sortStatus: 'desc',
            task: 'airport_all',
          }
          // 如果有時間範圍，加入時間參數
          if (state.search.start && state.search.end) {
            params.start = state.search.start
            params.end = state.search.end
          }
          const { result } = await reqList(params)
          // 使用 recentTotal 作為總數（或 billList.length，視 API 回應而定）
          const total =
            result.recentTotal ||
            (result.billList && result.billList.length) ||
            0
          commit('setAirportTransferPagingTotalEntries', total)
          commit(
            'setAirportTransferPagingTotalPages',
            Math.ceil(total / state.airportTransferPaging.npp),
          )
          commit('setAirportTransferList', result.billList || [])
          // console.log("機場接送", result);
        }
      } catch (e) {
        console.error(e)
        Notification({
          title: '提取訂單失敗，請稍後再試',
          type: 'error',
        })
      } finally {
        loading.close()
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/transaction/actions.js